<template>
    <div class="mvt-commentsuggest">
        <div v-if="visibleSuggestions.length" class="suggest-pills flex wrap gap-1">
            <button
                v-for="item in visibleSuggestions"
                :key="`${item.index}`"
                type="button"
                class="btn medium toggle"
                @click="onPillClick(item)"
            >
                {{ item.display }}
            </button>
        </div>
        <textarea
            :id="id"
            ref="textarea"
            :name="name"
            :maxlength="maxlength"
            :placeholder="placeholder"
            v-model="innerValue"
            v-validate="validate"
        ></textarea>
    </div>
</template>

<script src="./mvt-commentsuggest.js"></script>

<style lang="scss">
@use "./mvt-commentsuggest.scss" as *;
</style>
